import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={styles.loading}>
        <div style={styles.loadingInner}>
          <img
            src={process.env.REACT_APP_CENTRE_LOGO_URL}
            alt="Loading"
            style={styles.logo}
          />
          <div style={styles.loadingText}>Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    const roleRoutes = {
      admin:       '/dashboard',
      centreAdmin: '/dashboard',
      healer:      '/healer',
      patient:     '/patient',
      student:     '/student',
      general:     '/general',
      owner:       '/owner',
      superadmin:  '/superadmin',
    };
    const dest = user.role === 'healer' && user.primaryMode === 'solo'
      ? '/solo/healer'
      : roleRoutes[user.role];
    return <Navigate to={dest || '/dashboard'} replace />;
  }

  return children;
};

const styles = {
  loading: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #071e12 0%, #0c2617 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  loadingInner: { textAlign: 'center' },
  logo: { height: '52px', marginBottom: '16px' },
  loadingText: {
    fontFamily: "'Raleway', sans-serif",
    fontSize: '13px',
    fontWeight: '700',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.4)'
  }
};

export default ProtectedRoute;